/** @jsx jsx */
import React, { Fragment } from 'react'

import styled from '@emotion/styled'
import { jsx, Box, Flex, Text } from 'theme-ui'

import Container from '../components/Container'
import SEO from '../components/SEO'
import StyledHeading from '../components/shared/Typography/Heading/Heading'
import { graphql } from 'gatsby'
import Accordion from '../components/shared/Accordion/Accordion'
import Body from '../components/shared/Typography/Body/Body'
import Hero from '../components/blocks/Hero'
import { GorgiasButton } from '../components/footer/ColumnLink'
import Button from '../components/shared/Buttons/Button'

const StyledBody = styled(Body)`
  font-weight: 300;
  color: white;
  margin-bottom: 5px;
`

const FAQ = ({ data }) => {
  const faqList = data.allGoogleFaqSheet.nodes
  const faqCategories = []
  data.allGoogleFaqSheet.edges.map(i => {
    if (i.next != null) {
      const cat = i.next.category
      if (!faqCategories.includes(cat) && cat != null) {
        faqCategories.push(cat)
      }
    }
  })
  return (
    <Fragment>
      <SEO title="FAQ - JAXXON" description="Frequently Asked Questions" />
      <Container
        fullWidth
        sx={{
          backgroundColor: 'black',
          height: '55vh',
        }}
      >
        <Flex
          sx={{
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <StyledHeading
            as="h1"
            variant="semiBold"
            sx={{
              color: 'white',
              marginBottom: '24px',
              fontSize: [4, 5, 5, 6, 8],
            }}
          >
            HOW CAN WE HELP?
          </StyledHeading>
          <StyledBody variant="body1">
            SEND US A TEXT: 1-213-376-2959
          </StyledBody>
          <StyledBody variant="body1">
            GIVE US A CALL: 1-213-663-1585
          </StyledBody>
          <StyledBody variant="body1">MONDAY - FRIDAY 6am - 5pm PST</StyledBody>
          <GorgiasButton
            render={({ setShowGorgias }) => (
              <Button
                onClick={() => setShowGorgias()}
                variant="whiteSecondary"
                sx={{
                  minWidth: ['200px', '260px'],
                  padding: '13px 18px',
                  marginTop: '25px',
                }}
              >
                Chat With Us
              </Button>
            )}
          />
        </Flex>
      </Container>
      <Container sx={{ px: [12, 20, 20, 20, 20, 70] }}>
        <StyledHeading as="h2" variant="semiBold" sx={{ my: 25 }}>
          FAQ's
        </StyledHeading>
        <Hero
          inline
          backgroundVideoUrl="https://www.youtube.com/embed/Ueq3Ib-vUUA"
          sx={{ mb: 40 }}
        />
        {faqCategories.map((c, k) => {
          return (
            <Flex
              key={k}
              sx={{
                flexWrap: 'wrap',
              }}
            >
              <StyledHeading
                as="h4"
                variant="semiBold"
                sx={{
                  borderTop: 'default',
                  py: [25, 25, 12],
                  width: ['100%', '100%', '35%'],
                  letterSpacing: '1.5px',
                }}
              >
                {c}
              </StyledHeading>
              <Box
                sx={{
                  flex: ['100%', '100%', '65%'],
                }}
              >
                {faqList.map((i, k) => {
                  if (i.answer != null && i.category === c) {
                    return (
                      <Accordion
                        headingStyles={{
                          textTransform: 'none',
                          fontWeight: 'semiBold',
                          letterSpacing: '1.5px',
                        }}
                        bodyStyles={{
                          fontWeight: 'normal',
                        }}
                        sx={{
                          borderTop: ['none', 'none', 'default'],
                          borderBottom: ['default', 'default', 'none'],
                          py: 30,
                        }}
                        key={k}
                        title={i.dropdown}
                        renderItem={<Body variant="body2">{i.answer}</Body>}
                      />
                    )
                  }
                })}
              </Box>
            </Flex>
          )
        })}

        {/* {faqList.map((i, k) => {
          if (i.answer != null) {
            return (
              <Box
                sx={{
                  pl: '20em',
                }}
              >
                <Accordion
                  key={k}
                  title={i.dropdown}
                  renderItem={<Body variant="body2semibold">{i.answer}</Body>}
                />
              </Box>
            )
          }
        })} */}
      </Container>
    </Fragment>
  )
}

export const query = graphql`
  query FaqPage {
    allGoogleFaqSheet {
      nodes {
        answer
        category
        dropdown
      }
      edges {
        next {
          category
        }
      }
    }
  }
`

export default FAQ
